<template>
  <section>
    <b-button v-b-modal.email-template-modal size="sm" variant="primary" class="mr-2">
      <i class="fa fa-plus" aria-hidden="true"></i> Add
    </b-button>
    <b-modal
      id="email-template-modal"
      ref="email-template-modal"
      size="xl"
      @ok="sendEmailApi"
      @shown="initializeModal"
      @hidden="$emit('clearProps')"
      :ok-title=" isSaving ? 'Saving...' : 'Save'"
      :ok-disabled="isSaving"
      title="Email"
      scrollable
    >
      <div class="modal-body">
      <b-row>
          <b-col>
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="Message Format">
              <b-form-select class="w-auto mr-5" v-model="emailTemplate.msgFormat">
                <option value="HTML">HTML</option>
                <option value="TEXT">Text</option>
              </b-form-select>
            </b-form-group>
            <!-- <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="Category">
              <b-form-select class="w-auto mr-5" v-model="emailTemplate.emailTemplateCategoryId">
                <option :value="0">Select category</option>
                <option v-for="category in sortSelect(templateCategory)" :key="category.id" :value="category.id">{{category.name}}
                </option>
              </b-form-select>
            </b-form-group> -->
            <!-- <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="Source">
              <lookup-dropdown label="email source" moduleName="emailSources" lookupId="43" resource="EmailSources"
                propKey="emailTemplateSourceId" :value="emailTemplate.emailTemplateSourceId" :options="emailSources" @change="onValuesChange" />
            </b-form-group> -->
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8">
              <b-form-checkbox v-model="emailTemplate.isAdminOnly">
                Is Admin Only
              </b-form-checkbox>
            </b-form-group>
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="Template Name">
              <b-form-input
                v-model.trim="emailTemplate.name"
                @blur="$v.emailTemplate.name.$touch()"
                :class="{ 'is-invalid': $v.emailTemplate.name.$error }"
              ></b-form-input>
            </b-form-group>
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="To Recipients">
              <b-form-input
                v-model.trim="emailTemplate.toRecipients"
                @blur="$v.emailTemplate.toRecipients.$touch()"
                :class="{ 'is-invalid': $v.emailTemplate.toRecipients.$error }"
              ></b-form-input>
              <b-form-invalid-feedback>Please enter valid email</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="Cc Recipients">
              <b-form-input
                v-model.trim="emailTemplate.ccRecipients"
                @blur="$v.emailTemplate.ccRecipients.$touch()"
                :class="{ 'is-invalid': $v.emailTemplate.ccRecipients.$error }"
              ></b-form-input>
              <b-form-invalid-feedback>Please enter valid email</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8" label="Bcc Recipients">
              <b-form-input
                v-model.trim="emailTemplate.bccRecipients"
                @blur="$v.emailTemplate.bccRecipients.$touch()"
                :class="{ 'is-invalid': $v.emailTemplate.bccRecipients.$error }"
              ></b-form-input>
              <b-form-invalid-feedback>Please enter valid email</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols="2" label-align="right" class="mt-2 col-8 required" label="Subject">
              <b-form-input
                v-model.trim="emailTemplate.subject"
                @blur="$v.emailTemplate.subject.$touch()"
                :class="{ 'is-invalid': $v.emailTemplate.subject.$error }"
              ></b-form-input>
              <b-form-invalid-feedback>Please enter subject</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Body" class="required">
              <vue-editor v-model.trim="emailTemplate.body"
                          @blur="$v.emailTemplate.body.$touch()"
                          :class="{ 'is-invalid': $v.emailTemplate.body.$error }"></vue-editor>
              <div class="invalid-feedback" v-bind:style="{ display: $v.emailTemplate.body.$error ? 'block':'none' }">
                Please enter body
              </div>
              <b-form-invalid-feedback>Please enter body</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import service from '../../service';
  import { VueEditor } from 'vue2-editor';
  import { required, email } from 'vuelidate/lib/validators';
  import { multiEmailValidator } from '@/shared/validators';

  export default {
    components: {
      VueEditor,
    },
    props: {
      templateData: {
        type: Object, default: () => {
        },
      },
    },
    data() {
      return {
        emailTemplate: {},
        isSaving: false,
        templateCategory: [],
      };
    },
    validations: {
      emailTemplate: {
        name: { required },
        toRecipients: { multiEmailValidator },
        ccRecipients: { multiEmailValidator },
        bccRecipients: { multiEmailValidator },
        subject: { required },
        body: { required },
      },
    },
    computed: {
      ...mapGetters('lookup', ['emailSources'])
    },
    methods: {
      ...mapActions('lookup', ['getLookupValueById']),
      async initializeModal() {
        this.emailTemplate = {
          id: 0,
          // emailTemplateSourceId: 0,
          emailTemplateCategoryId: 0,
          name: '',
          toRecipients: '',
          subject: '',
          ccRecipients: '',
          bccRecipients: '',
          body: '',
          msgFormat: 'HTML',
          emailAccountId: 1,
          isAdminOnly: false,
          active: true,
        };
        if (this.templateData.id) {
          this.emailTemplate = { ...this.templateData };
        }
        this.$v.emailTemplate.$reset();
        if (!this.templateCategory.length) {
          this.templateCategory = await this.getLookupValueById(53);
        }
      },
      onValuesChange({ id }) {
        console.log('Test?', id)
        this.emailTemplate.emailTemplateSourceId = id;

      },
      sendEmailApi: async function(e) {
        this.$v.emailTemplate.$touch();
        if (this.$v.emailTemplate.$invalid) {
          e.preventDefault();
          return;
        }

        e.preventDefault();
        try {
          this.isSaving = true;
          const result = await service.manageEmailTemplate(this.emailTemplate);
          this.isSaving = false;
          if (result) {
            this.$v.emailTemplate.$reset();
            this.$emit('onChange');
            this.$root.$emit('bv::hide::modal', 'email-template-modal');
          }
        }catch (e) {
          this.isSaving = false;
        }
      },
    },
    mounted() {
      this.$v.emailTemplate.$reset();
    },
  };
</script>
